import {firstBy} from 'thenby'

export const sortStarterCourses = (arr) => {
  return arr.sort(firstBy('grade_level_id').thenBy('name'))
}



// WEBPACK FOOTER //
// ./src/utils/sorter.js